module.exports = __webpack_public_path__ + "static/img/xjDLogo.cf98375f.png";